/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
export class AbstractValue {
}
//# sourceMappingURL=types.js.map